import styled from 'styled-components'

export const WrapperModal = styled.div`
  border-top-left-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 90vw;
  max-height: 80vh;
  height: 100%;
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow: hidden;
  background-color: #fff;

  .map {
    width: 50%;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      width: 100%;
      height: 250px;
    }
  }
`

export const Content = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  flex: 1;
  padding: ${({ theme }) => theme.padding(2)};
`

export const MapContainer = styled.div`
  width: 45%;
  min-height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    height: 30vh;
    width: 100%;
    min-height: auto;
  }
`

export const Title = styled.div`
  background-color: ${({ theme }) => theme.colors.primary};
  padding: ${({ theme }) => theme.padding(2)};
  border-top-left-radius: ${({ theme }) => theme.borderRadius};
  border-top-right-radius: ${({ theme }) => theme.borderRadius};

  h2 {
    color: ${({ theme }) => theme.colors.lightText};
    margin: 0;
    padding: 0.5rem 2.5rem 0.5rem 0;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      font-size: 1.2rem;
    }
  }
`

export const InfoContainer = styled.div<{ $hasStreetView?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ $hasStreetView }) =>
    $hasStreetView ? 'minmax(320px, 0.95fr) minmax(0, 1.15fr)' : '1fr'};
  gap: 1.25rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }
`

export const VisualCard = styled.section`
  display: flex;
  min-width: 0;
  min-height: 320px;
  border-radius: ${({ theme }) => theme.borderRadius};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.lightGrey};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    min-height: 280px;
  }
`

export const VisualCardBody = styled.div`
  flex: 1;
  min-height: 0;
`

export const InfoCard = styled.section`
  min-width: 0;
  padding: 1rem 1.25rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: #fff;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    padding: 1rem;
  }
`

export const SectionGroup = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const GeneralInformation = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  min-width: 0;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }

  .social-name {
    grid-column: 1 / -1;
  }
`

export const Header = styled.header`
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.padding(2)};
  color: ${({ theme }) => theme.colors.lightText};
  font-size: 16px;
  font-weight: 500;
`

export const OtherInformation = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  align-items: start;

  .street-name {
    grid-column: 1 / -1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }
`

export const BottomContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
  min-width: 0;
`

export const LeftBottomInformation = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }
`

export const RightBottomInformation = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    grid-template-columns: 1fr;
  }
`

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`

export const Input = styled.input`
  padding: 8px;
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 1px solid ${({ theme }) => theme.colors.mediumGrey};
  width: 100%;
  pointer-events: none;
  background-color: #fff;
`

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.darkText};
  font-size: 16px;
  font-weight: 500;
`
